import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormValidator } from '../common/services/formValidator.service';
import { RouteHandlerService } from './../common/services/routeHandler.service';
import { Router } from '@angular/router';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { CommonConstants } from '../common/utilities/commonConstants';
import { ActivitiHandlerService } from './../common/services/activitiHandler.service';
import { ConfigService } from './../common/services/config.service';
import { CookieHandlerService } from './../common/services/cookieHandler.service';
import { SharedService } from 'src/app/common/services/sharedService';
import { HomeComponent } from './../home/home.component';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { Formatter } from './../common/services/formatter';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { AnalyticsService } from '../common/services/device.analytics.service';
import { HttpClientModule } from '@angular/common/http';
import { HttpInterceptor } from '../common/services/httpInterceptor.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';
import { DrawerComponent } from '../common/utilities/drawer/drawer.component';
import { PincodeHandlerService } from '../common/services/pincodeHandler.service';
import { VehicleSummaryContent } from '../applicationModule/quickQuestions/content';
import { WhatsappConsentService } from '../common/services/consent.service';
import { AEMFragmentService } from '../common/services/aemFragment.service';
import { environment } from 'src/environments/environment';
import { ClevertapEventHandlerService } from '../common/services/clevertap-event-handler.service';
import { SsoService } from '../common/services/sso.service';
import { DialogService } from 'src/app/common/components/dialog/dialog.service';
import { DialogRef } from 'src/app/common/components/dialog/dialog-ref';
import { CommonErrorMessageDrawerComponent } from 'src/app/common/components/dialog/common-error-message-drawer/common-error-message-drawer.component';
import { filter, first } from 'rxjs/operators';

const DOB_DATE_RANGES = {
  MaxAge: 70,
  MinAge: 18
};
import { VehicleDetailService } from 'src/app/common/services/vehicleDetail.service';
import { EmitterService } from 'src/app/common/services/emitter.service';
import { VehicleRegistrationService } from 'src/app/common/services/vehicle-registration.service';

const VehicleTypes = [
  { name: 'Private Car', productCategoryCode: 'FWGI' },
  { name: 'Two Wheeler', productCategoryCode: 'TWGI' }
  // { name: 'Taxi', productCategoryCode: 'TXGI' },
  // { name: 'Commercial (Auto, Truck, etc)', productCategoryCode: 'CVGI' }
];
@Component({
  selector: 'app-vehicle-registration-details',
  templateUrl: './vehicleRegistration.template.html',
  styleUrls: ['./vehicleRegistration.style.scss'],
  providers: [HomeComponent, HttpClientModule]
})
export class VehicleRegistrationComponent implements OnInit {
  public showDrawer: boolean = false;
  @ViewChildren(PopupComponent) public PopupComponent: QueryList<any>;
  public VehicleRegistrationForm: FormGroup;
  public MobileVerificationForm: FormGroup;
  // tslint:disable-next-line:max-line-length
  public IsCorrectMobile: string = null;
  private payload;
  public IsEnabled = false;
  public Config = { show: false, backdrop: 'static' };
  public IsValid = false;
  public isReadOnly: boolean;
  public ServiceError: string;
  public showLoader: boolean;
  public VehicleType;
  public Vehiclevalue: any;
  public ShowPageloader = false;
  public setRegistrationDataFlag = false;
  public visitorID: any;
  public isMobile: boolean;
  public WrongOtpMsg: string = null;
  public MobileOtpTrails = 0;
  public IsOTPResend = false;
  public OTPResend = 0;
  public OTPFieldVisibility: boolean;
  public OtpRetryMsg: string;
  public futureDateError: any;
  public vehicleTypeCheck: string;
  @ViewChildren(DrawerComponent) public drawer: QueryList<DrawerComponent>;
  public vehicleTypeData = VehicleTypes;
  public termsContent = VehicleSummaryContent.Terms_Conditions_Content_Bagic;
  public ShowConsent = false;
  public whatsAppConsent = true;
  public today = new Date();
  public bflJourney: any;
  private MobileOtpReceived = false;
  private isServiceError: boolean;
  private selectedRtoLocation: any;
  private outputPayload = {};
  private callBack: any;
  private PreviousPolicyDetails: ActivitiModel.PreviousPolicyDetails;
  private UtmParamsDetails = <Model.UtmParamsDetails>{};
  vehicleSelected: any;
  city: any;
  firstVariations;
  bannerPointText: any = [];
  bannerPointDesc: any = [];
  bannerDesc: any = [];
  bannerText: any = [];
  aemFragmentInfo: any;
  appQuoteCriteriaId: any;
  focusInTime: any;
  vehicletypeError: any;
  applicationId: any;
  mobileNumber: any;
  public ServiceErrorCode: string;
  //vehicleType_errorMessages = ["apdm-248", "apdm-249", "apdm-250"];
  backFlow: any;
  ssoEnabled: boolean;
  vehicleRegCheck = false;
  offer: string;
  respayload: any;
  inValidRegNoError: string;
  count: number = 0;
  regNo: any;
  public title: string;
  public desc: string;
  public enableGetQuoteButton: boolean = false;
  vehicleRegistrationFormID: string;
  isBhSeriesFlag: boolean;
  invalidPatternErrorMsg: string = CommonConstants.invalidPatternErrorMsg;
  public customerNameErrMsg: string = CommonConstants.LABELPLACEHOLDERS.errorMESG.customerNameErrMsg;
  public labelPlaceholder = CommonConstants.LABELPLACEHOLDERS;

  constructor(
    private router: Router,
    public FormValidators: FormValidator,
    private _formBuilder: FormBuilder,
    private _activitiHandler: ActivitiHandlerService,
    private _cookieHandler: CookieHandlerService,
    public _sharedService: SharedService,
    private homeComponent: HomeComponent,
    private _routeContextProvider: RouteContextProvider,
    private _sessionHandlerService: SessionHandlerService,
    private _routerService: RouteHandlerService,
    private _formatter: Formatter,
    private _analyticsService: AnalyticsService,
    private _adobe_analytics_service: adobe_analytics_service,
    private _httpInterceptor: HttpInterceptor,
    private _pincodeService: PincodeHandlerService,
    private _whatsappConsentService: WhatsappConsentService,
    private _aemFragmentService: AEMFragmentService,
    public _cleverTapService: ClevertapEventHandlerService,
    private ssoService: SsoService,
    public _dialogService: DialogService,
    public _dialogRef: DialogRef,
    private _vehicleDetailService: VehicleDetailService,
    private _emitterService: EmitterService,
    private vehicleRegistrationService: VehicleRegistrationService
  ) {
    // this.isMobile = _analyticsService.GetDeviceDetails().mobile;
  }

  public ngOnInit() {
    this.setMobileValues();
    //this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.backToPlanlist, false);
    this.ssoEnabled = (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) === 'true') ? true : false;
    this.bflJourney = environment['bflenvironment'];
    //Prefill pincode and mobile number for mobile users
    this.prefillMobileUserData();

    if (!this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.JWToken)) {
      this.homeComponent.initateAuthentication(() => {
        // this.VehicleType = this._sharedService.getData(CommonConstants.QueryParamsKeys.InsuranceProductType).toString() ?
        //   this._sharedService.getData(CommonConstants.QueryParamsKeys.InsuranceProductType).toString() :
        //   this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
        this.VehicleType = 'FWGI';
        let InsProductType;
        let url: any = window.location.pathname;
        if (!this.VehicleType) {
          InsProductType = url.includes('car-insurance') ? 'FWGI' : url.includes('two-wheeler-insurance')
            ? 'TWGI' : url.includes('taxi-car-insurance-calculator') ? 'TXGI' :
              url.includes('commercial-vehicle-insurance-calculator') ? 'CVGI' : 'FWGI';
          this._sharedService.setData(CommonConstants.QueryParamsKeys.InsuranceProductType,
            InsProductType);
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
          this.VehicleType = InsProductType;
        }
        this.buildFormElement().then(res => this.subscribeToFormValueChanges()); //this is written so that form will build first and then only subscribeToFormValueChanges() will execute
        this.updateControls();
        this.showSEO();
        this.setRegistrationDetails(null);
        // this.VehicleRegistrationForm.controls['vehicleType'].setValue(VehicleTypes.find(x => x.productCategoryCode === this.VehicleType).name);
        this.vehicleSelected = VehicleTypes.find(x => x.productCategoryCode === this.VehicleType).name;
        this.Vehiclevalue = {
          value: this.vehicleSelected,
          id: this.VehicleType
        };
        this.getContentFragment();
      });
    } else {
      // this.VehicleType = this._sharedService.getData(CommonConstants.QueryParamsKeys.InsuranceProductType).toString() ?
      //   this._sharedService.getData(CommonConstants.QueryParamsKeys.InsuranceProductType).toString() :
      //   this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
      this.VehicleType = 'FWGI';
      let InsProductType;
      let url: any = window.location.pathname;
      if (!this.VehicleType) {
        InsProductType = url.includes('car-insurance') ? 'FWGI' : url.includes('two-wheeler-insurance')
          ? 'TWGI' : url.includes('taxi-car-insurance-calculator') ? 'TXGI' :
            url.includes('commercial-vehicle-insurance-calculator') ? 'CVGI' : 'FWGI';
        this._sharedService.setData(CommonConstants.QueryParamsKeys.InsuranceProductType,
          InsProductType);
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, InsProductType);
        this.VehicleType = InsProductType;
      }
      this.buildFormElement().then(res => this.subscribeToFormValueChanges()); //this is written so that form will build first and then only subscribeToFormValueChanges() will execute
      this.updateControls();
      this.showSEO();
      this.setRegistrationDetails(null);
      this.vehicleSelected = VehicleTypes.find(x => x.productCategoryCode === this.VehicleType).name;
      this.Vehiclevalue = {
        value: this.vehicleSelected,
        id: this.VehicleType
      };
      this.getContentFragment();
      try {
        this.backFlow = JSON.parse(this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.backFlow)) || false;
      } catch (error) {
        this.backFlow = false;
      }

      if (this.backFlow) {
        this.backFlow = this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.backFlow, false);
        this.getDetails();
      }

    }
    //Updating meta tags based on vehicle type 
    const metaTag: HTMLMetaElement | null = document.querySelector('meta[name="tag-3"]');
    if (metaTag) {
      if (this._sessionHandlerService.GetSession('insProductType') == 'FWGI') {
        metaTag.content = 'car-insurance';
      }
      else {
        metaTag.content = 'two-wheeler insurance';
      }
    }
    //CX-ID attribute tagging
    this.defineCXIDAttribute();
    // setTimeout(() => {
    //this.ShowPageloader = false;
    // }, 2000);
    // Get Adobe author visitor id
    if (this.bflJourney) {
      document.getElementById('hdfc-ergo-section').style.setProperty('display', 'none');
    }
    setTimeout(() => {
      this.visitorID = window['_satellite']?.getVisitorId()['getMarketingCloudVisitorID']();
    }, 5000);
  }

  subscribeToFormValueChanges() {
    const controlsToWatch = Object.keys(this.VehicleRegistrationForm.controls)
      .filter(controlName => controlName !== 'vehicleType');
    controlsToWatch.forEach(controlName => {
      if (this.VehicleRegistrationForm.controls[controlName].value != '') {
        this.enableGetQuoteButton = true;
      }
    })


    controlsToWatch.forEach(controlName => {
      this.VehicleRegistrationForm.get(controlName).valueChanges
        .pipe(filter(value => value.trim() != ''),
          first())
        .subscribe(() => {
          this.enableGetQuoteButton = true;

        });
    });
  }


  // Remove query params from the URL
  removeQueryParams() {
    this.router.navigate(
      [],
      {
        queryParams: {
          token: null,   // Remove token query param
          key: null, // Remove key query param
        },
        queryParamsHandling: 'merge',
      }
    );
  }

  prefillMobileUserData() {
    this.isMobile = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1' || this._sessionHandlerService.GetSession('source') === 'mobileApp';
    if (this.isMobile) {
      this.VehicleRegistrationForm?.controls['mobileNumber'].setValue(this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobile_number));
      this.VehicleRegistrationForm?.controls['pinCode'].setValue(this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.pin_code));
    }
  }

  prefillUserData() {
    const payload = {
      "mobileNumber": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobile_number)
    };
    this.ssoService.getPrefilledUserData(payload).subscribe((response: any) => {
      if (response) {
        if (response?.mobileNo) {
          this.VehicleRegistrationForm.controls['mobileNumber'].setValue(response?.mobileNo);
          this.ValidateMobile();
          this.isReadOnly = true;
        } else {
          this.isReadOnly = false;
        }
        const customerFullname = (response.firstName === null ? '' : response.firstName + ' ') + (response.middleName === null ? '' : response.middleName + ' ') + (response.lastName === null ? '' : response.lastName);
        this.VehicleRegistrationForm.controls['pinCode'].setValue(response?.pinCode);
        this.VehicleRegistrationForm.controls['customerName'].setValue(customerFullname);
        const ev = { target: { value: response.pinCode } }
        this.OnPincodeChange(ev);
      }
    }, (error: any) => {
      console.log('error', error);
      this.isReadOnly = true;
    });
  }

  public IsPaste(event) {
    event.preventDefault();
  }
  public ChangeModalSize(modalSize) {
    const element = document.querySelector('.modal-dialog');
    element.classList.add(modalSize);
  }

  private getDetails() {
    this.showLoader = true;
    this.IsValid = true;
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JourneyType, '');
    const InsuranceProductType = this._sharedService.getData(CommonConstants.QueryParamsKeys.InsuranceProductType);
    if (InsuranceProductType) {
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, InsuranceProductType);
    }
    this._activitiHandler.GetCallService().subscribe((res: ActivitiModel.MTResponse<any>) => {
      if (!res.error) {
        if (res) {
          this.showLoader = false;
          this.payload = res['wGIQuoteCriteria'];
          this.mobileNumber = res['mobile'];
          this.setRegistrationDetailsMob(this.payload, this.mobileNumber);
        }
      } else {
        this._sessionHandlerService.DeleteSession([CommonConstants.CookieKeys.processId]);
        this.showLoader = false;
      }

    });
  }

  private setRegistrationDetailsMob(data, mobile) {
    const registrationNumber = data.registrationNumber ? data.registrationNumber : '';
    const customerFullname = (data.firstName === null ? '' : data.firstName + ' ') + (data.middleName === null ? '' : data.middleName + ' ') + (data.lastName === null ? '' : data.lastName);
    if (registrationNumber) {
      this.setRegistrationNumber(registrationNumber);
    }
    const fullName = (data.firstName ? data.firstName + ' ' : '') +
      (data.middleName ? data.middleName + ' ' : '') +
      (data.lastName ? data.lastName : '');

    this.VehicleRegistrationForm.controls['mobileNumber'].setValue(mobile);
    this.VehicleRegistrationForm.controls['customerName'].setValue(customerFullname);
    this.bflJourney ? this.VehicleRegistrationForm.controls['vehicleType'].setValue(VehicleTypes.find(x => x.productCategoryCode === data.productCategoryCode).name) : '';
    this.VehicleRegistrationForm.controls['pinCode'].setValue(data.pinCode);
  }

  private setRegistrationNumber(registrationNumber) {
    if (registrationNumber.includes('-')) {
      registrationNumber = registrationNumber.split('-');
      registrationNumber = registrationNumber.join('');
    }
    this.VehicleRegistrationForm.controls['registrationNumber'].setValue(registrationNumber ? registrationNumber : '');
  }

  // Next Button Click
  public Next() {
    // if (this._routeContextProvider.GetQueryParams('utm_source') === 'Affiliate') {
    //   this.getModalDirectiveInstanceBasedOnId('mobileVerification').show();
    //   this.SendMobileOTP();
    // } else {
    // Set mobile number 
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobileNumber, this.VehicleRegistrationForm.controls['mobileNumber'].value);
    if (this.VehicleRegistrationForm.valid && !this.customerNameErrMsg) {
      this.showLoader = true;
      this.ServiceError = null;
      const inquiriesPaylaod = this.createPayloadForInquireis();
      this.applicationCreation(inquiriesPaylaod);
    } else {
      Object.keys(this.VehicleRegistrationForm.controls).forEach((key: any) => {
        const control = this.VehicleRegistrationForm.get(key);
        control.markAsTouched();
      });
      const commonValuesForCleverTap = {
        vehicleType: this.VehicleType == "FWGI" ? "PRIVATE CAR" : "2WH",
        vehicleRegistrationNumber: this.VehicleRegistrationForm.controls['registrationNumber'].value,
        mobileNumber: this.VehicleRegistrationForm.controls['mobileNumber'].value,
        pinCode: this.VehicleRegistrationForm.controls['pinCode'].value
      }
      this._cleverTapService.setCommonCleverTapObjValueInSessionStorage(commonValuesForCleverTap);
      this._cleverTapService.cleverTapForVehicleRegistrationPageCta();
      //}
    }
  }

  public ShowChildModal(id: string): void {
    this.getModalDirectiveInstanceBasedOnId(id).show();
  }
  public ValidateDOB(updatedValue) {
    if (!this.VehicleRegistrationForm) { return null; }
    const formData = { ...this.VehicleRegistrationForm.value, ...updatedValue };
    if (formData.day && formData.month && formData.year) {
      let validationErr = null;
      const DOBObj = {
        Day: formData.day,
        Month: formData.month,
        Year: formData.year
      };
      const error = this.FormValidators.IsDateOfBirthValid(DOBObj, null, DOB_DATE_RANGES.MinAge, DOB_DATE_RANGES.MaxAge);
      if (error) {
        console.log(error);
        return { rangeError: error };
      } else {
        const currDate = new Date();
        const dobDate = new Date(DOBObj.Year, DOBObj.Month, DOBObj.Day);
        if (currDate < dobDate) {
          validationErr = { rangeError: 'Date of birth can\'nt be more than current date' };
        }
      }
      const cl = Object.keys(updatedValue)[0];
      ['year', 'month', 'day']
        .filter(c => c !== cl)
        .forEach(c => this.VehicleRegistrationForm.controls[c].setErrors(validationErr));
      return validationErr;
    }
  }
  public VerifyOTP(formValue: FormData) {
    this.showLoader = true;
    this.IsOTPResend = false;
    const outputPayload = {
      otp: formValue['otp'],
      mobile: this.VehicleRegistrationForm.controls['mobileNumber'].value,
      source: CommonConstants.SourceTypes.Journey,
      dateOfBirth: '1800-01-01',
    };
    if (this.MobileOtpTrails >= 5) {
      return;
    }
    this._httpInterceptor.Post(ConfigService.getInstance()
      .getConfigObject().APIURL.resumeSendOtp, outputPayload)
      .subscribe((mtResponse: ActivitiModel.MTResponse<any>) => {
        this.showLoader = false;
        if (!mtResponse.errorBean) {
          this.getModalDirectiveInstanceBasedOnId('mobileVerification').hide();
          this.Next();
        } else {
          this.WrongOtpMsg = 'Please provide a valid OTP.';
          this.showLoader = false;
        }
      });
  }
  public NextAction(action) {
    window.location.href = 'https://www.bajajfinservmarkets.in';
  }
  // Validate Mobile Number
  public ValidateMobile() {
    const mobileNo = this.VehicleRegistrationForm
      .controls['mobileNumber'].value;
    const test = /(\d)\1{9}/g;
    if (mobileNo && !this.FormValidators.FieldHasErrors(this.VehicleRegistrationForm, 'mobileNumber')) {
      if (mobileNo[0] === '6' || mobileNo[0] === '7' || mobileNo[0] === '8' || mobileNo[0] === '9') {
        this.IsCorrectMobile = null;
        this.IsValid = true;
        // Commented against BFSDINSTSK-17363 jira  
        // this.GetWhatsappConsent();
      } else {
        if (mobileNo.length === 10) {
          this.IsCorrectMobile = 'Mobile number should start with 6, 7, 8, 9';
          this.IsValid = false;
        }
      }
      if (mobileNo.match(test)) {
        this.IsCorrectMobile = 'Please provide valid mobile number.';
      }
    } else {
      this.IsCorrectMobile = null;
    }
  }
  public BlockSpecialChar($event) {
    const k = $event.keyCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8 || (k >= 48 && k <= 57));
  }
  public SendMobileOTP(): void {
    this.getOTP(this.onOTPReceived);
  }
  public OnPincodeChange($event) {
    this._pincodeService.OnPinCodeChanged($event, () => {
      console.log(this._pincodeService.LocationErrorMessage,
        this._pincodeService.GeoLocationDetails);
      if (this._pincodeService.GeoLocationDetails) {
        this.VehicleRegistrationForm.controls['pinCode']
          .setValue(this._pincodeService.GeoLocationDetails.pinCode);
        this._sharedService.setData('GeoLocationDetails', this._pincodeService.GeoLocationDetails);
        this.city = this._pincodeService.GeoLocationDetails.city;
      } else {
        this.VehicleRegistrationForm.controls['pinCode'].setValue('');
      }
    });
  }
  public validateYear() {
    const dateError = this.ValidateDOB({ ['year']: this.VehicleRegistrationForm.controls['year'].value });
    if (dateError) {
      this.VehicleRegistrationForm.controls['year'].setErrors(dateError);
    }
  }
  // open drawer
  public openDrawer(itemId) {
    this.showDrawer = true;
    this.drawer.filter((item, index) => {
      return (itemId === item.drawerId);
    })[0].open();
    const body = document.body;
    body.style.overflowY = 'hidden';
    this.vehicleTypeCheck = this.VehicleRegistrationForm.controls['vehicleType'].value;
  }
  public setVehicleType(event, vehicleType?: string) {
    this.Vehiclevalue = {
      value: event.target.value,
      id: event.target.id
    };
    this.vehicleSelected = event.target.value;
    this.googleAnalyticVehicleType(this.vehicleSelected);
  }
  public confirmVehicleType() {
    this.VehicleRegistrationForm.controls['vehicleType'].setValue(this.Vehiclevalue.value);
    this.googleAnalyticTabOut('confirm');
    this.showDrawer = false;
    const body = document.body;
    body.style.overflowY = 'auto';
    this.drawer.filter((item, index) => {
      return ('vehicleTypeDrawer' === item.drawerId);
    })[0].close();
    if (this.vehicleTypeCheck != this.vehicleSelected) {
      this.changeUrl(this.Vehiclevalue.id);
    }
  }
  public googleAnalyticTabOut(ClickText) {
    if (this.bflJourney) {
      if (ClickText == 'confirm') {
        let dataLayer: any = window['dataLayer'];
        let controlValue = this.Vehiclevalue.id;
        dataLayer.push({
          'event': 'button_click',
          'pageType': 'Vehicle Registration Page',
          'productName': controlValue === 'FWGI' ? 'Four Wheeler Motor Insurance' : controlValue === 'TWGI' ? 'Two Wheeler Motor Insurance' : controlValue === 'TXGI' ? 'Taxi Insurance' : controlValue === 'CVGI' ? 'Commercial Vehicle Insurance' : '',
          'productid': controlValue,
          'customerType': '',
          'vehicleType': controlValue,
          'clickText': ClickText
        });
      }
      if (ClickText == 'GET QUOTE') {
        let dataLayer: any = window['dataLayer'];
        let controlValue = this.VehicleType;
        dataLayer.push({
          'event': 'button_click',
          'pageType': 'Vehicle Registration Page',
          'productName': this.vehicleSelected + ' Motor Insurance',
          'productid': controlValue,
          'clickText': ClickText,
          'validation': 'Successful',
          'customerType': '',
          'customerId': '',
          'userId': '',
          'leadId': '',
          'mobile': this.VehicleRegistrationForm.controls['mobileNumber'].value,
          'pinCode': this.VehicleRegistrationForm.controls['pinCode'].value,
          'city': this.city,
          'appQuoteCriteriaId': this.appQuoteCriteriaId,
          'stagePercentage': '',
          'applicationId': this.applicationId
        });
      }


    }
  }
  public changeUrl(vehicleType) {
    // switch(profItem.)
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.InsProductType, vehicleType);
    this.VehicleType = vehicleType;
    if (window.location.pathname !== '/vehicleRegistration') {
      let bflJourney = this._sharedService.isBFLJourney();
      let pathnameString = '';
      switch (vehicleType) {
        case 'TWGI':
          pathnameString = this.bflJourney ? 'marketplace/' + CommonConstants.ProdUrlString.TwoWheeler.pathname + '/' : CommonConstants.ProdUrlString.TwoWheeler.pathname + '/';
          break;
        case 'FWGI':
          pathnameString = this.bflJourney ? 'marketplace/' + CommonConstants.ProdUrlString.FourWheeler.pathname + '/' : CommonConstants.ProdUrlString.FourWheeler.pathname + '/';
          break;
        case 'TXGI':
          pathnameString = this.bflJourney ? 'marketplace/' + CommonConstants.ProdUrlString.Taxi.pathname + '/' : CommonConstants.ProdUrlString.Taxi.pathname + '/';
          break;
        case 'CVGI':
          pathnameString = this.bflJourney ? 'marketplace/' + CommonConstants.ProdUrlString.Commercial.pathname + '/' : CommonConstants.ProdUrlString.Commercial.pathname + '/';
          break;
        default:
          pathnameString = this.bflJourney ? 'marketplace/' + CommonConstants.ProdUrlString.TwoWheeler.pathname + '/' : CommonConstants.ProdUrlString.TwoWheeler.pathname + '/';
      }
      window.location.pathname = pathnameString;
    }
  }
  // check for mobileNum eligible for whatsapp consent or not
  public GetWhatsappConsent() {
    const mobile = this.VehicleRegistrationForm.controls['mobileNumber'].value;
    const requestPayload = {
      mobileno: mobile
    };
    if (mobile && this.VehicleRegistrationForm.controls['mobileNumber'].valid && !this.IsCorrectMobile) {
      this._whatsappConsentService.GetConsent(requestPayload).subscribe((response) => {
        if (response.payload.cnsentflg == null || response.payload.cnsentflg === 0) {
          this.ShowConsent = true;
          this.checkUserConsent();
        } else {
          this.ShowConsent = false;
        }
      });
    }
  }//  check for consent status
  public checkUserConsent() {
    const mobile = this.VehicleRegistrationForm.controls['mobileNumber'].value;
    let whatsAppConsent: number;
    this.whatsAppConsent ? whatsAppConsent = 1 : whatsAppConsent = 0;
    const requestPayload = {
      'cnsentflg': whatsAppConsent,
      'consentChannel': 'WhatsApp',
      'consentIp': '',
      'consentProviderType': 'Customer',
      'consentUrl': null,
      'consentdt': this.today,
      'consentsource': 'Digital Platform',
      'deviceId': null,
      'email': null,
      'mobileno': mobile,
      'revokedt': null,
      'userkey': null
    };
    this._whatsappConsentService.AddConsent(requestPayload).subscribe((response) => {
    });
  }
  public removeClass() {
    this.showDrawer = false;
    this.drawer.filter((item, index) => {
      return ('vehicleTypeDrawer' === item.drawerId);
    })[0].close();
  }
  public closePopUp() {
    this.showDrawer = false;
    this.drawer.filter((item, index) => {
      return ('termsDrawer' === item.drawerId);
    })[0].close();
  }
  private applicationCreation(inquiriesPaylaod: any) {
    this._activitiHandler.PostCallService(inquiriesPaylaod).subscribe((resp) => {
      const Haserror = resp.errorBean;
      this.setUserAuthToken(resp);
      if (resp.error) {
        // Common error dialog box for application error message 400
        if (resp?.status === 400 && CommonConstants.applicationCreationErrorCode.includes(resp?.error[0]?.errorCode)) {
          this.openCommonErrorDialog('commonErrorMessageDrawer', resp?.error[0]?.errorMessage);
        } else if (!this.bflJourney && resp?.status === 401) {

        } else if (resp?.error[0]?.errorCode && CommonConstants.vehicleType_errorMessages.includes(resp?.error[0]?.errorCode.toLowerCase())) {
          this.vehicletypeError = resp?.error[0].errorMessage;
        } else if (!this.bflJourney && (resp?.error)[0]?.errorCode == '401 UNAUTHORIZED') {
          this.vehicletypeError = "The selected plan is currently unavailable. Please try after sometime";
        }
        else {
          this.vehicletypeError = "Invalid vehicle type."
        }
        this.showLoader = false;
      }
      if (!Haserror) {
        if (resp.payload) {
          const nextPage = resp.nextTask.nextTaskKey;
          const appId = resp.payload.applicationId;

          if (this.bflJourney) {
            this.appQuoteCriteriaId = resp.payload.appQuoteCriteriaId;
            this.applicationId = resp.payload.applicationId;
            this.googleAnalyticTabOut('GET QUOTE');
          } else {
            this._adobe_analytics_service.applicationCreated(appId, inquiriesPaylaod?.payload?.mobile, inquiriesPaylaod?.payload?.quoteCriteria.wGIQuoteCriteria.dateOfBirth,
              inquiriesPaylaod?.payload?.quoteCriteria.wGIQuoteCriteria.registrationNumber, resp?.payload?.appQuoteCriteriaId, '', 'CUSTOMER',
              resp.nextTask.processId, resp.nextTask.nextTaskKey, '');
          }
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.QuoteCriteriaId, resp.payload.appQuoteCriteriaId);
          const appIdFromCookie = + this._cookieHandler.GetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId);
          if (((appId === appIdFromCookie) && appId && appIdFromCookie)
            && !this._analyticsService.GetDeviceDetails().mobile) {
            this._routerService.RouteToNextTask('multitabfailed');
            return;
          }
          if (resp.nextTask.processId) {
            this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.processId,
              this._formatter.removeDoubleQuotes(resp.nextTask.processId));
          }
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.LoanApplicationId, resp.payload.applicationId);
          this._cookieHandler.SetCookie(CommonConstants.CookieKeys.LoanApplicationId, appId, appId);
          if (nextPage === 'productListing') {
            this.SetSessionQuoteId(resp.payload.quoteIds);
            this._routerService.RouteToNextTask(nextPage);
          } else if (nextPage === 'previousPolicyDetail') {
            this._routeContextProvider.NavigateToViewWithQueryParams
              ([CommonConstants.Routes.PlanListing.PlanProductListing], { type: 'previousPolicyUpdate' });
          } else {
            window.scrollTo(0, 0);
            this._routerService.RouteToNextTask(nextPage);
          }
        }
      } else {
        this.isServiceError = true;
        this.showLoader = false;
        if (Haserror) {
          Haserror.forEach(element => {
            if (CommonConstants.serviceErrors.includes(element.errorCode)) {
              this.ServiceError = element.errorMessage;
            } else {
              this.ServiceError = '';
            }
          });
        }
      }
    });
  }

  private getModalDirectiveInstanceBasedOnId(popupId: string): any {
    if (this.PopupComponent) {
      return this.PopupComponent.filter((item: PopupComponent, index: number) => {
        return item.id === popupId;
      })[0].modalControl;
    }
  }
  private createPayloadForInquireis() {
    const formValue = this.VehicleRegistrationForm.value;
    const dob = this.getDOBString(formValue);
    const insProductType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
    let tabKey, roleKey, userKey;
    const epUserDetails = this.decodeEPObject(CommonConstants.CookieKeys.epUserDetails);
    if (epUserDetails && epUserDetails.roleKey) {
      roleKey = epUserDetails.roleKey;
      userKey = epUserDetails.userKey;
    }
    const epTokenDetails = this.decodeEPObject(CommonConstants.CookieKeys.epTokenDetails);
    if (epTokenDetails && epTokenDetails.tabKey) {
      tabKey = epTokenDetails.tabKey;
    }
    //Full name field split in array for firstname, middlename, lastname
    const customerName = this.VehicleRegistrationForm.controls['customerName'].value.trim().split(' ');

    const inquiriesPayload = {
      'payload': {
        'tabKey': tabKey ? tabKey : null,
        'roleKey': roleKey ? roleKey : null,
        'userKey': userKey ? userKey : null,
        'mobile': formValue.mobileNumber,
        'productCategoryCode': insProductType,
        'assetDetailReq': true,
        'applicationUTMParams': this._sharedService.UtmStamping(),
        'userrolekey': this.setrolekey.toString(),
        'quoteCriteria': {
          'pinCode': this.VehicleRegistrationForm.controls['pinCode'].value,
          'wGIQuoteCriteria': {
            'applicationId': this.applicationId || null,
            'registrationNumber': formValue.registrationNumber.toUpperCase(),
            'commercialVehicle': false,
            'policyExpired': 'N',
            'pinCode': this.VehicleRegistrationForm.controls['pinCode'].value,
            // 'firstName': this._formatter.GetName('first', this.VehicleRegistrationForm.controls['proposerName'].value),
            // 'middleName': this._formatter.GetName('middle', this.VehicleRegistrationForm.controls['proposerName'].value),
            // 'lastName': this._formatter.GetName('last', this.VehicleRegistrationForm.controls['proposerName'].value),
            "firstName": this.vehicleRegistrationService.customerNameGetValue('firstname', customerName),
            "middleName": this.vehicleRegistrationService.customerNameGetValue('middleName', customerName),
            "lastName": this.vehicleRegistrationService.customerNameGetValue('lastName', customerName)

          }
        }
      }
    };
    return inquiriesPayload;
  }
  private setUserAuthToken(responseData: any) {
    if (responseData) {
      if (responseData.headers) {
        const authToken = responseData.headers.get('authtoken');
        if (authToken !== null && authToken !== '') {
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, authToken);
        }
      }
      if (responseData.headers) {
        const sessionToken = responseData.headers.get('X-Session-Token');
        if (sessionToken !== null && sessionToken !== '') {
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.sessionId, sessionToken);
        }
      }
    }
  }
  // Build the form Controls.
  private buildFormElement() {
    this.VehicleRegistrationForm = this._formBuilder.group({
      registrationNumber: ['', [Validators.required, this._sharedService.validateInput]],
      pinCode: ['', [Validators.required]],
      mobileNumber: ['', Validators.compose([Validators.required])],
      customerName: ['', Validators.compose([Validators.required, this._formatter.removeSpaces])],
    });
    this.MobileVerificationForm = this._formBuilder.group({
      otp: ['', Validators.compose([Validators.required])]
    });
    this.VehicleRegistrationForm.controls['mobileNumber'].valueChanges.subscribe(() => {
      this.callBack = null;
      this.IsCorrectMobile = null;
    });
    this.VehicleRegistrationForm.controls['registrationNumber'].valueChanges.subscribe((value: string) => {
      this.vehicleRegCheck = true;
      if (this.VehicleRegistrationForm.controls['registrationNumber'].value !== '') {
        this.enableGetQuoteButton = true;
      }
      if ((this.backFlow ? this.count > 1 : true) && this.regNo !== this.VehicleRegistrationForm.controls['registrationNumber'].value &&
        (!this.VehicleRegistrationForm.get('registrationNumber')?.hasError('validateInput')) &&
        !this.VehicleRegistrationForm.get('registrationNumber')?.hasError('required')) {
        this.isBhSeriesFlag = value.includes('BH');
        // In case of BH series we are not validating registration number with API call
        if (!this.isBhSeriesFlag) {
          this.validateRegNo();
        }
      } else {
        this.inValidRegNoError = null;
        this.vehicleRegCheck = false;
      }

      this.callBack = null;
      this.ServiceError = null;
    });

    this.MobileVerificationForm.valueChanges.subscribe((updatedValue) => {
      this.WrongOtpMsg = null;
    });
    //Prefill pincode and mobile number for mobile users
    this.prefillMobileUserData();
    this.detectValueChanges();
    // If user is coming through insurance mall and is already logged in there, prefill details
    setTimeout(() => {
      if (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) === "true" || this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.miniOrangeToken) == 'true') {
      //call DEMOG API
      this.prefillUserData();
      this.removeQueryParams();
    } else if (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) === "false") {
      this.removeQueryParams();
    }
    }, 1000)
    
    return new Promise<void>((resolve, reject) => {
      resolve();
    });
  }

  //This method use for get on value changes
  public detectValueChanges() {
    // Customer Name valuechanges control
    this.VehicleRegistrationForm['controls'].customerName.valueChanges.subscribe((customerName) => {
      this.customerNameErrMsg = this.vehicleRegistrationService.validateCustomerName(customerName, false);
    });
  }

  private updateControls() {
    if (this.bflJourney) {
      this.VehicleRegistrationForm.addControl('vehicleType', new FormControl('', [Validators.required]));
      this.VehicleRegistrationForm.controls['vehicleType'].setValue(VehicleTypes.find(x => x.productCategoryCode === this.VehicleType).name);
    }
  }
  private getDOBString(formValue: FormData) {
    const day = parseInt(formValue['day'], 10) < 10 ? '0' + parseInt(formValue['day'], 10) : formValue['day'];
    const month = parseInt(formValue['month'], 10) < 10 ? '0' + parseInt(formValue['month'], 10) : formValue['month'];
    const year = formValue['year'];
    return year + '-' + month + '-' + day;
  }

  get setrolekey() {
    let UTM: any = this._sessionHandlerService.GetSession('UTM');
    UTM = UTM.split(':');
    if (UTM.length && UTM[1] === 'Callcentre' && !isNaN(+UTM[4])) {
      return +UTM[4];
    } else {
      return '';
    }
  }
  private getOTP(callback): void {
    this.IsOTPResend = false;
    this.ServiceErrorCode = null;
    if (this.MobileOtpTrails === 4) {
      this.MobileOtpTrails = 5;
      this.IsOTPResend = true;
    }
    if (this.MobileOtpTrails !== 5) {
      this.outputPayload['mobile'] = this.VehicleRegistrationForm.controls['mobileNumber'].value;
      this.outputPayload['productCode'] = CommonConstants.LOAN_PRODUCT_CODES.Motor_Insurance;
      this.outputPayload['insProductType'] = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
      this.outputPayload['otp'] = CommonConstants.DEFAULT_EMPTY_STRING;
      this.outputPayload['source'] = CommonConstants.SourceTypes.Journey;
      this.outputPayload['mfa'] = true;
    }
    this._httpInterceptor.Post(ConfigService.getInstance()
      .getConfigObject().APIURL.resumeGetOtp, this.outputPayload)
      .subscribe((response) => {
        if (!response.errorBean) {
          callback.call(this, response);
          this.MobileOtpTrails++;
          this.IsOTPResend = true;
          this.MobileOtpReceived = true;
        } else if (CommonConstants.errorCodes.includes(response.errorBean[0].errorCode)) {
          this.IsOTPResend = false;
          this.ServiceError = response.errorBean[0].errorMessage;
          this.ServiceErrorCode = response.errorBean[0].errorCode;
        }
      });
  }
  private onResendOTPReceived(mtResponse: ActivitiModel.MTResponse<any>) {
    if (mtResponse.errorBean) {
      // this.IsServiceFailure = true;
    }
  }
  private onOTPReceived(mtResponse: ActivitiModel.MTResponse<any>) {
    if (!mtResponse.errorBean) {
      this.OTPFieldVisibility = true;
    }
  }
  private setRegistrationDetails(data) {
    const mobNum = '';
    const registrationNumber = '';
    this.VehicleRegistrationForm.controls['mobileNumber'].setValue(mobNum);
    this.VehicleRegistrationForm.controls['registrationNumber'].setValue('');
    this.setRegistrationDataFlag = true;
    if (data && data.dateOfBirth) {
      const dateObj = data.dateOfBirth ? data.dateOfBirth.split('-') : '';
      const day = parseInt(dateObj[2], 10) < 10 ? '0' + parseInt(dateObj[2], 10) : dateObj[2];
      const month = parseInt(dateObj[1], 10) < 10 ? '0' + parseInt(dateObj[1], 10) : dateObj[1];
      const year = dateObj[0];
      this.VehicleRegistrationForm.controls['day'].setValue(day);
      this.VehicleRegistrationForm.controls['month'].setValue(month);
      this.VehicleRegistrationForm.controls['year'].setValue(year);
    }
    this.disableMobileControl();
  }

  private SetSessionQuoteId(quoteIds: any) {
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.PlanQuoteIds, JSON.stringify(quoteIds));
  }
  private showSEO() {

    if (!this.bflJourney) {
      document.getElementById('footerElementBFL').style.display = 'none';
      if (this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1') {
        document.getElementById('footerContainerColor').style.display = 'none';
      } else {
        document.getElementById('footerContainerColor').style.display = 'block';
      }
    } else {
      document.getElementById('footerElementBFL').style.display = 'block';
      document.getElementById('footerContainerColor').style.display = 'none';
    }
  }

  public getContentFragment() {

    this._aemFragmentService.getAemDetailsLandingpage().subscribe((res) => {
      this.aemFragmentInfo = res.properties.elements;
      this.modifyBannerContent();
    });
  }
  /* Function for sorting and manipulating the AEM Banner content */
  public modifyBannerContent() {
    const filtered = Object.keys(this.aemFragmentInfo).filter(key => key.includes('sellingPoint')).reduce((obj, key) => {
      obj[key] = this.aemFragmentInfo[key];
      return obj;
    }, {});
    for (let index = 1; index < Object.keys(filtered).length; index++) {
      const bannerPointText = Object.keys(filtered).filter(key => !key.includes('SubText'))
        .reduce((obj, key) => {
          obj[key] = filtered[key];
          return obj;
        }, {});
      const bannerPoint = Object.values(bannerPointText);
      this.bannerPointText = bannerPoint.sort(this.sortElement);
      const bannerPointDesc = Object.keys(filtered).filter(key => key.includes('SubText'))
        .reduce((obj, key) => {
          obj[key] = filtered[key];
          if (obj[key])
            return obj;
        }, {});
      const banDesc = Object.values(bannerPointDesc);
      this.bannerPointDesc = banDesc.sort(this.sortElement);
    }
    this.bannerPointText.forEach(element => {
      if (element.variations[this.VehicleType.toLowerCase()].value) {
        this.bannerText.push(this.removeInnerElement(element.variations[this.VehicleType.toLowerCase()].value));
      }

    });
    this.bannerPointDesc.forEach(element => {
      if (element.variations[this.VehicleType.toLowerCase()].value) {
        this.bannerDesc.push(this.removeInnerElement(element.variations[this.VehicleType.toLowerCase()].value));
      }
    });
  }
  public sortElement(a, b) {
    if (a.title < b.title)
      return -1;
    if (a.title > b.title)
      return 1;
    return 0;
  }
  public removeInnerElement(value) {
    let tmp = document.createElement('div');
    tmp.innerHTML = value;
    return tmp.textContent || tmp.innerText || '';
  }
  public SetFocusTime() {
    this.focusInTime = new Date().getTime();
  }
  public googleAnalyticfieldTiming(inputFieldname) {
    if (this.bflJourney) {
      let dataLayer: any = window['dataLayer'];
      let controlValue = this.VehicleRegistrationForm.controls['vehicleType'].value;
      let fieldValue = this.VehicleRegistrationForm.controls[inputFieldname].value;
      let validation, action;
      if (inputFieldname == 'registrationNumber') {
        action = 'Registration Number';
        validation = (this.FormValidators.HasError(this.VehicleRegistrationForm, 'registrationNumber', 'pattern') ||
          this.FormValidators.HasError(this.VehicleRegistrationForm, 'registrationNumber', 'required') || this.ServiceError
        ) ? 'Fail' : 'Success';
      }
      if (inputFieldname == 'mobileNumber') {
        action = 'Mobile Number';
        validation = (this.FormValidators.HasError(this.VehicleRegistrationForm, 'mobileNumber', 'required') ||
          this.FormValidators.HasError(this.VehicleRegistrationForm, 'mobileNumber', 'minlength') || this.IsCorrectMobile
        ) ? 'Fail' : 'Success';
      }
      if (inputFieldname == 'pinCode') {
        action = 'Pin Code';
        validation = (this.FormValidators.HasError(this.VehicleRegistrationForm, 'pinCode', 'required') ||
          this.FormValidators.HasError(this.VehicleRegistrationForm, 'pinCode', 'pattern')
        ) ? 'Fail' : 'Success';
      }

      const focusOutTime = new Date().getTime();
      const totalDuration = (focusOutTime - this.focusInTime) / 1000;
      dataLayer.push({
        'event': 'fieldTiming',
        'eventCategory': 'Form Analytics Actions',
        'eventAction': inputFieldname == 'registrationNumber' ? controlValue + ' ' + action : action, // Eg. Full Name
        'eventLabel': validation, // Success or Fail
        'eventValidation': validation === 'Success' ? 'Yes' :
          !fieldValue ? 'Please provide ' + action : this.IsCorrectMobile ? this.IsCorrectMobile :
            'Enter a valid ' + action, // if Success – Yes or if Fail - Error message
        'section': this.VehicleType === 'FWGI' ? 'Four Wheeler' : this.VehicleType === 'TWGI' ? 'Two Wheeler' : this.VehicleType === 'TXGI' ? 'Taxi' : this.VehicleType === 'CVGI' ? 'Commercial Vehicle' : '' + ' Insurance',
        'eventValue': totalDuration// Duration (Time spent by user on the field)
      });
    }
  }
  public googleAnalyticVehicleType(selected) {
    if (this.bflJourney) {
      let dataLayer: any = window['dataLayer'];
      const focusOutTime = new Date().getTime();
      const totalDuration = (focusOutTime - this.focusInTime) / 1000;
      dataLayer.push({
        'event': 'fieldTiming',
        'eventCategory': 'Form Analytics Actions',
        'eventAction': selected ? selected : '',
        'eventLabel': 'Success',
        'eventValidation': 'Yes',
        'section': this.VehicleType === 'FWGI' ? 'Four Wheeler' : this.VehicleType === 'TWGI' ? 'Two Wheeler' : this.VehicleType === 'TXGI' ? 'Taxi' : this.VehicleType === 'CVGI' ? 'Commercial Vehicle' : '' + ' Insurance',
        'eventValue': totalDuration// Duration (Time spent by user on the field)
      });
    }
  }
  private disableMobileControl() {
    this.isMobile = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1' || this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.platform) === 'android' || this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.platform) === 'ios' || this.ssoEnabled === true;
    if (this.isMobile) {
      this.VehicleRegistrationForm.controls['mobileNumber'].setValue(this._sessionHandlerService.GetSession("mobile_number"));
      this.VehicleRegistrationForm?.controls['pinCode']?.setValue(this._sessionHandlerService.GetSession("pin_code"));
      this.ValidateMobile();
      this.VehicleRegistrationForm.updateValueAndValidity();
    }
  }

  private decodeEPObject(epCookieString: string) {
    let decodedEPObject;
    if (this._cookieHandler.GetCookie(epCookieString)) {
      const decodedString = decodeURIComponent(this._cookieHandler.GetCookie(epCookieString));
      decodedEPObject = JSON.parse(decodedString);
    }
    return decodedEPObject;
  }
  public validateRegNo() {
    if (!this.isBhSeriesFlag) {
      const regNo = this.VehicleRegistrationForm.controls['registrationNumber'].value;

      if (!this.VehicleRegistrationForm.get('registrationNumber')?.hasError('required') && !this.VehicleRegistrationForm.get('registrationNumber')?.hasError('pattern')) {
        if (regNo) {
          this._activitiHandler.getValidateRegistrationNo(regNo.toUpperCase()).subscribe((res: ActivitiModel.MTResponse<any>) => {
            this.vehicleRegCheck = false;
            if (res.error) {
              this.inValidRegNoError = res.error[0].errorMessage ? res.error[0].errorMessage : 'Invalid Vehicle Registration Number. Please re-enter.',
                this.VehicleRegistrationForm.controls['registrationNumber'].setErrors(res.error[0].errorMessage);
              this.VehicleRegistrationForm.updateValueAndValidity();
            } else {
              this.inValidRegNoError = null;
              if (!this.VehicleRegistrationForm.get('registrationNumber')?.hasError('pattern')) {
                this.VehicleRegistrationForm.controls['registrationNumber'].setErrors(null);
                this.VehicleRegistrationForm.updateValueAndValidity();
              }
            }
          }, (error => {
            this.vehicleRegCheck = false;
          }));
        }
      } else {
        this.inValidRegNoError = null;
        this.vehicleRegCheck = false;
      }
    }
  }
  public onFocusField(data) {
    if (data.target.name === 'registrationNumber') {
      this.count++;
      this.regNo = this.VehicleRegistrationForm.controls['registrationNumber'].value;
      console.log("count", this.count, "  reg ", this.regNo)
    }
  }

  public openCommonErrorDialog(drawerName, errorMessage) {
    this._dialogRef = this._dialogService.open(CommonErrorMessageDrawerComponent, {
      data: {
        title: 'Oops',
        desc: errorMessage
      },
      panelClass: drawerName,
      hasBackdrop: true,
      disableClose: true,
      showMinimizedButton: true,
      closeOnOutsideClick: false
    });
    this._dialogRef.afterClosed.subscribe(result => {
      this.closeCommonErrorDialog();
    });
  }

  public closeCommonErrorDialog() {
    this.VehicleRegistrationForm.reset();
  }

  defineCXIDAttribute() {
    const vehicleType = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType);
    if (vehicleType === 'TWGI') {
      this.vehicleRegistrationFormID = "Bike_GetQuote";
    }
    else if (vehicleType === 'FWGI') {
      this.vehicleRegistrationFormID = "Car_GetQuote";
    }
  }

  private setMobileValues() {
    this._emitterService.Get(CommonConstants.EmitterEventTypes.MobileAppCheck)
      .emit(this._routeContextProvider.GetQueryParams
        (CommonConstants.QueryParamsKeys.IsMobile));
    // Set Mobile cookie
    let mobileState = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.IsMobile) === '1' || this._sessionHandlerService.GetSession('source') === 'mobileApp' ? '1' : '0';
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.MobileState, mobileState);
  }

  //On blur full name validation
  onBlurCustomerName() {
    const fullNameControl = this.VehicleRegistrationForm['controls'].customerName;
    this.customerNameErrMsg = this.vehicleRegistrationService.validateCustomerName(fullNameControl.value, true);
  }

}
